import * as XLSX from "xlsx";

/**
 * Descarga un .xlsx a partir de filas y columnas.
 * @param {{ rows: Array<Object>, columns: Array<{ label: string, field?: string, value?: (row) => any }>, fileName: string, sheetName?: string }} params
 */
export const exportarExcel = ({ rows, columns, fileName, sheetName = "Datos" }) => {
  const data = rows.map((row) =>
    columns.reduce(
      (acc, column) => ({
        ...acc,
        [column.label]: column.value ? column.value(row) : row[column.field],
      }),
      {}
    )
  );
  const sheet = XLSX.utils.json_to_sheet(data, {
    header: columns.map((column) => column.label),
  });
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, sheet, sheetName.slice(0, 31));
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};
